<template>
  <div
    class="grid h-full w-full place-content-center rounded-sm"
    :style="{
      backgroundColor: colors.bgColor,
      color: colors.textColor,
    }"
  >
    <app-icon :icon="icon" />
  </div>
</template>

<script lang="ts" setup>
import { iconFillVariant } from "@pollen/ui-library";

import { tagColors } from "~/business-areas/tag/composables/tag.utils";

const properties = defineProps<{
  tag: DatabaseTable<"tags">;
  active?: boolean;
}>();

const colors = tagColors(properties.tag);
const icon = computed(() =>
  properties.active
    ? iconFillVariant(properties.tag.icon)
    : properties.tag.icon,
);
</script>
